<template>
  <div class="exam-page" v-title data-title="卓考网校|历年真题">
    <header class="g-header-container">
      <c-header title="历年真题" />
    </header>
    <main class="g-view-container">
      <div v-if="list.length" class="container">
        <template v-for="item in list">
          <exam-item
            :id="item.courseSectionId"
            :title="item.name"
            @tap="onTap"
            :key="item.courseSectionId"
          />
        </template>
      </div>
      <van-empty v-else description="暂无真题" />
    </main>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import examItem from './item';

  export default {
    name: 'exam',
    data() {
      return {
        professionId: this.$route.params.professionId || 1,
        list: [],
      };
    },
    components: {
      CHeader,
      examItem,
    },
    created() {
      this.axios
        .get(
          `https://api.zhuokao360.com/section/querySection?sectionType=8&professionId=${this.professionId}`,
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.data;
          }
        });
    },
    methods: {
      onTap(e) {
        const { id } = e;
        this.$router.push(`/analysis/${id}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
</style>
